"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12.5 12h3v7h3v-7h3V9h-9z"
}), _react.default.createElement("path", {
  d: "M15.5 4h-13v3h5v12h3V7h5z"
})), 'TextFieldsTwoTone');

exports.default = _default;